module.exports = __webpack_public_path__ + "img/weixinphone.52ecad42.png";